import { render } from "./AddPartA.vue?vue&type=template&id=016ee021"
import script from "./AddPartA.vue?vue&type=script&lang=js"
export * from "./AddPartA.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__